<template>
  <div class="promote flex flex-y">
    <div class="width-full text-0 relative">
      <img
        class="width-full"
         :src="require('@/assets/images/promote/bg.png') + `?timestamp=${new Date().valueOf()}`"
        alt="邀请车主奖13元现金"
      />
      <button class="absolute text-14 text-white" @click="handleRule">活动规则</button>
    </div>
    <div class="content text-14 text-500 text-center">
      <!-- <div style="color: #FFEAE0">长按保存图片分享给好友 好友扫码领取奖励</div> -->
      <div class="qrcode">
        <vue-qr
          ref="qr"
          :text="url"
          :margin="15"
        />
        <a class="driverQrImg" style="visibility: hidden" />
        <button @click="onDownload"><img class="width-full" src="@/assets/images/promote/qrcode/btn.png" alt="" /></button>
      </div>
    </div>
    <canvas ref="canvas" :width="width" :height="height" v-show="false">
      你的浏览器不支持canvas！
    </canvas>
    <van-popup v-model="show" style="width: 60%; background-color: transparent">
      <div class="flex-y align-center">
        <img v-if="postUrl" :src="postUrl" alt="" srcset="" />
        <div class="bg-primary text-white margin-top-20 padding-tb-4 padding-lr-16 text-16" style="border-radius: 20px;">长按图片保存</div>
        <div class="text-white text-30 margin-top-16">
           <van-icon name="close" @click="show = false" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import Vue from 'vue'
import { Popup } from 'vant'
import { ossUrl, handleApp } from '@/utils/handle_app'

Vue.use(Popup)

export default {
  data () {
    const { userId } = this.$store.state.auth

    return {
      isMiniprogram: window.__wxjs_environment === 'miniprogram',
      url: `${ossUrl}/#/promote/driver/register?userId=${userId}`,
      postUrl: '',
      show: false,
      width: 375,
      height: 812
    }
  },
  components: {
    VueQr
  },
  methods: {
    handleRule () {
      this.$router.push('/agreement/detail/21165000000003')
    },
    onDownload () {
      const url = this.$refs.qr.$el.src
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const coverImage = new Image()
      coverImage.src = require('@/assets/images/promote/driver-qr.png')
      coverImage.onload = () => {
        ctx.drawImage(coverImage, 0, 0, this.width, this.height)
        const qrImage = new Image()
        qrImage.src = url
        qrImage.onload = () => {
          ctx.drawImage(qrImage, 116, 580, 142, 142)
          ctx.fillStyle = '#ffffff'
          ctx.font = '14px sans-serif'
          ctx.textAlign = 'center'
          ctx.fillText('好友扫码领取奖励', 188, 560, 142, 142)
          const imgUrl = canvas.toDataURL('image/jpeg', 1)
          handleApp('saveImg', { url: imgUrl }, (params, flag) => {
            if (flag) {
              this.postUrl = imgUrl
              this.show = true
            } else {
              const a = document.querySelector('.driverQrImg')
              a.download = '邀请好友' + new Date().getTime()
              a.href = imgUrl
              a.dispatchEvent(new MouseEvent('click'))
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.promote {
  min-height: 100vh;
  background-color: #FF5C1A;

  button {
    padding: 0px;
    margin: 0px;
    outline: none;
    border: none;
    text-align: center;
    background-color: transparent;
  }

  .text-0 {
    font-size: 0px;
  }

  .text-500 {
    font-weight: 500;
  }

  .text-17 {
    font-size: 17px;
  }

  .text-11 {
    font-size: 11px;
    color: #ffaa93;
  }

  .text-700 {
    font-weight: 700;
    font-size: 25px;
    font-family: DIN Alternate, DIN Alternate-Bold;
  }

  img + button.absolute {
    width: 85px;
    height: 30px;
    right: 0px;
    top: 8.395%;
    color: #FFE0D4;
    background-color: rgba(255, 255, 255, 0.22);
    border-radius: 15px 0px 0px 15px;
  }

  .content {
    padding: 23px 20px 40px;
  }

  .qrcode {
    & > img {
      width: 37.8%;
      border-radius: 4px;
      margin: 20px auto 25px;
    }
  }

}
</style>
